import { registerSmarticoProfileEventHandler } from '~/handlers/register-smartico-profile-event';
import { NativeEvent } from '~/shared/NativeBridge/NativeEvent';
import { SmarticoProfileEvent } from '~/shared/smartico/smartico-profile-event';
import { isRunningInIosNativeApp } from '~/utils/browserInfo';

export const useSmarticoProfileEvent = () => {
  const { userId } = useUserData();

  // Chamado pelo `setAuth` da store de auth, por onde passa TODA autenticacao
  // (login, 2FA, biometria, cadastro, verificacao de e-mail, `loginSuccess` do
  // iframe). Ficava so nos tres componentes de login, e por isso quem se
  // cadastrava pelo app so ganhava a prop no primeiro login explicito depois
  // disso — em producao, 31% das contas mais novas estavam sem ela.
  const sendAuthEvent = async (): Promise<void> => {
    if (!NativeEvent.isNativeApp()) return;

    // Plataforma via deteccao local (user-agent + bridge), NAO via atribuicao
    // AppsFlyer: o recado `appsflyerUid` da bridge e suprimido quando o
    // usuario nega o ATT (iOS), o que deixava `journeyStore.appsflyer.platform`
    // vazio e silenciava este evento para praticamente todo iOS.
    const platform = isRunningInIosNativeApp() ? 'IOS' : 'ANDROID';

    const userExtId = String(userId.value || '');

    if (!userExtId) return;

    try {
      await registerSmarticoProfileEventHandler({
        event: SmarticoProfileEvent.UpdateProfile,
        user_ext_id: userExtId,
        payload: { core_custom_prop25: platform },
      });
    } catch (e) {
      console.error('[smartico-profile-event] failed', e);
    }
  };

  return { sendAuthEvent };
};
